import { Injectable, inject } from '@angular/core';
import Keycloak from 'keycloak-js';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly keycloak = inject(Keycloak);

  get isAuthenticated(): boolean {
    return this.keycloak.authenticated ?? false;
  }

  get token(): string | undefined {
    return this.keycloak.token;
  }

  get username(): string | undefined {
    return this.keycloak.tokenParsed?.['preferred_username'];
  }

  get roles(): string[] {
    const realmRoles = this.keycloak.tokenParsed?.['realm_access']?.['roles'] ?? [];
    const resourceRoles = this.keycloak.tokenParsed?.['resource_access']?.[environment.keycloak.clientId]?.['roles'] ?? [];
    return [...realmRoles, ...resourceRoles];
  }

  hasRole(role: string): boolean {
    return this.roles.includes(role);
  }

  logout(): void {
    this.keycloak.logout({
      redirectUri: window.location.origin
    });
  }

  login(): void {
    this.keycloak.login();
  }

  get tokenParsed(): Keycloak.KeycloakTokenParsed | undefined {
    return this.keycloak.tokenParsed;
  }

  async loadUserProfile(): Promise<Keycloak.KeycloakProfile> {
    return this.keycloak.loadUserProfile();
  }

  async updateToken(minValidity = 30): Promise<boolean> {
    return this.keycloak.updateToken(minValidity);
  }
}
